export enum ControlPanelType {
  None = 'None',
  Standard = 'Standard',
  Compact = 'Compact',
  ControllerOnly = 'ControllerOnly',
}
